import { render } from "./ArtInvestTeamView.vue?vue&type=template&id=4f8b6eb3&scoped=true"
import script from "./ArtInvestTeamView.vue?vue&type=script&lang=js"
export * from "./ArtInvestTeamView.vue?vue&type=script&lang=js"

import "./ArtInvestTeamView.vue?vue&type=style&index=0&id=4f8b6eb3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8b6eb3"]])

export default __exports__